import routes from './home.routes'

export const homeModule = {
  routes
}
